import React from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { includedGroups } from '../../data/websites';
export function WhatsIncluded() {
  return <section aria-labelledby="whats-included" className="bg-white px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-1124" data-mp="3nv0sg9jecfay">
      <h2 id="whats-included" className="max-w-[24ch] text-[clamp(2rem,3vw,3.5rem)] font-extrabold leading-tight tracking-tight text-brand-black" data-id="element-1125" data-mp="5kyldcjlhkyd">
        What’s included with every website
      </h2>

      <div className="mt-12 grid gap-10 lg:grid-cols-3 xl:gap-16" data-id="element-1126" data-mp="amxn6hzos9t7">
        {includedGroups.map(group => <div key={group.title} data-id="element-1127" data-mp="oe2hd4kac9w5">
            <h3 className="border-b-2 border-brand-black pb-3 text-lg font-bold text-brand-black" data-id="element-1128" data-mp="od13ytfsrbb9">{group.title}</h3>
            <ul className="mt-5 space-y-3" data-id="element-1129" data-mp="jgsqrll5ts6q">
              {group.items.map(item => <li key={item} className="flex gap-3 text-[clamp(1rem,1.05vw,1.1875rem)] leading-snug text-gray-700" data-id="element-1130" data-mp="yc8jnna07i1j">
                  <CheckIcon className="mt-0.5 h-5 w-5 flex-shrink-0 text-brand-red" strokeWidth={3} aria-hidden="true" data-id="element-1131" data-mp="tb2olisvfiou" />
                  {item}
                </li>)}
            </ul>
          </div>)}

        <div className="flex flex-col rounded-xl bg-brand-black p-8 xl:p-10" data-id="element-1132" data-mp="1ife7rkvl8km3">
          <h3 className="text-sm font-bold uppercase tracking-[0.14em] text-brand-red" data-id="element-1133" data-mp="1nez9g325772i">Your business system</h3>
          <p className="mt-4 text-[clamp(1.5rem,1.8vw,2.25rem)] font-extrabold leading-tight text-white" data-id="element-1134" data-mp="1sebx2q0u8i65">
            1Dash.Pro, Powered by HighLevel, built in.
          </p>
          <p className="mt-4 leading-relaxed text-gray-300" data-id="element-1135" data-mp="1xatwrbhb9qbm">
            Your website lives in the same account as your contacts, calendar, texting and reviews.
          </p>
          <a href="#/crm" className="group mt-auto inline-flex items-center gap-1.5 pt-8 font-bold text-white transition-colors duration-150 ease-out hover:text-brand-light focus:outline-none focus-visible:underline" data-id="element-1136" data-mp="264p1iieiteqq">
            See the 1Dash.Pro CRM
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1137" data-mp="g26jopsobf4p" />
          </a>
        </div>
      </div>
    </section>;
}